import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import {
  APP_STORE_URL,
  GOOGLE_PLAY_URL,
  WEB_DOWNLOAD_URL,
} from '../../constants/storeLinks';

declare global {
  interface Window {
    gtag: (
      command: string,
      targetId: string,
      config?: Record<string, unknown>,
    ) => void;
    opera?: string;
  }
}

const QRDownload = () => {
  useEffect(() => {
    const ua = navigator.userAgent || navigator.vendor || window.opera || '';
    let target = WEB_DOWNLOAD_URL; // Default to web for desktop
    let platform = 'desktop';

    // Track the visit
    if (window.gtag) {
      window.gtag('event', 'qr_download_visit', {
        user_agent: ua,
        referrer: document.referrer,
      });
    }

    if (/android/i.test(ua)) {
      target = GOOGLE_PLAY_URL;
      platform = 'android';
    } else if (/iPad|iPhone|iPod/.test(ua)) {
      target = APP_STORE_URL;
      platform = 'ios';
    }

    // Track the redirect
    if (window.gtag) {
      window.gtag('event', 'qr_redirect', {
        platform: platform,
        target_url: target,
      });
    }

    window.location.href = target;
  }, []);

  return (
    <div style={{ padding: '2rem', textAlign: 'center' }}>
      <Helmet>
        <title>Download Morph | AI Home Inspection App</title>
        <meta
          name="description"
          content="Download the Morph AI home inspection app for iOS and Android and start generating inspection reports on-site."
        />
        <link
          rel="canonical"
          href="https://www.morph-technologies.com/download"
        />
      </Helmet>
      <h2>Redirecting to Morph App...</h2>
      <p>
        If you are not redirected, <a href={WEB_DOWNLOAD_URL}>click here</a>.
      </p>
    </div>
  );
};

export default QRDownload;
